/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const timelineResponseOutputDaySlicesItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const timelineResponseOutputDaySlicesItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const timelineResponseOutputDaySlicesMax = 35;

export const timelineResponseOutputAgentsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const timelineResponseOutputAgentsItemDisplayNameMax = 500;

export const timelineResponseOutputAgentsItemInitialsMax = 8;

export const timelineResponseOutputAgentsMax = 1000;

export const timelineResponseOutputRangeStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const timelineResponseOutputRangeEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const timelineResponseOutputDisplayTimeZoneMax = 100;

export const timelineResponseOutputSchedulesItemScheduleIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const timelineResponseOutputSchedulesItemTimeZoneMax = 100;

export const timelineResponseOutputSchedulesItemVersionExclusiveMin = 0;
export const timelineResponseOutputSchedulesItemVersionMax = 9007199254740991;

export const timelineResponseOutputSchedulesItemRoutinesItemPendingHistoryOneStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const timelineResponseOutputSchedulesItemRoutinesItemPendingHistoryOneEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const timelineResponseOutputSchedulesItemRoutinesItemRoutineIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const timelineResponseOutputSchedulesItemRoutinesItemRotationCountExclusiveMin = 0;
export const timelineResponseOutputSchedulesItemRoutinesItemRotationCountMax = 2147483647;

export const timelineResponseOutputSchedulesItemRoutinesItemOriginalItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const timelineResponseOutputSchedulesItemRoutinesItemOriginalItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const timelineResponseOutputSchedulesItemRoutinesItemOriginalItemSourceScheduleIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const timelineResponseOutputSchedulesItemRoutinesItemOriginalItemSourceRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const timelineResponseOutputSchedulesItemRoutinesItemOriginalItemSourceRoutineVersionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const timelineResponseOutputSchedulesItemRoutinesItemOriginalItemSourcePositionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const timelineResponseOutputSchedulesItemRoutinesItemOriginalItemSourceOriginalUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const timelineResponseOutputSchedulesItemRoutinesItemOriginalItemSourceOverrideIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const timelineResponseOutputSchedulesItemRoutinesItemOriginalItemUserIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const timelineResponseOutputSchedulesItemRoutinesItemOriginalItemStartOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const timelineResponseOutputSchedulesItemRoutinesItemOriginalItemEndOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const timelineResponseOutputSchedulesItemRoutinesItemOriginalItemHistoryRecordedThroughOneRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const timelineResponseOutputSchedulesItemRoutinesItemOriginalMax = 10000;

export const timelineResponseOutputSchedulesItemRoutinesItemOverridesItemOverrideIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const timelineResponseOutputSchedulesItemRoutinesItemOverridesItemSubstituteUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const timelineResponseOutputSchedulesItemRoutinesItemOverridesItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const timelineResponseOutputSchedulesItemRoutinesItemOverridesItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const timelineResponseOutputSchedulesItemRoutinesItemOverridesMax = 10000;

export const timelineResponseOutputSchedulesItemRoutinesItemFinalItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const timelineResponseOutputSchedulesItemRoutinesItemFinalItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const timelineResponseOutputSchedulesItemRoutinesItemFinalItemSourceScheduleIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const timelineResponseOutputSchedulesItemRoutinesItemFinalItemSourceRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const timelineResponseOutputSchedulesItemRoutinesItemFinalItemSourceRoutineVersionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const timelineResponseOutputSchedulesItemRoutinesItemFinalItemSourcePositionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const timelineResponseOutputSchedulesItemRoutinesItemFinalItemSourceOriginalUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const timelineResponseOutputSchedulesItemRoutinesItemFinalItemSourceOverrideIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const timelineResponseOutputSchedulesItemRoutinesItemFinalItemUserIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const timelineResponseOutputSchedulesItemRoutinesItemFinalItemStartOffsetRegExp = new RegExp(
  '^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$',
);
export const timelineResponseOutputSchedulesItemRoutinesItemFinalItemEndOffsetRegExp = new RegExp(
  '^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$',
);
export const timelineResponseOutputSchedulesItemRoutinesItemFinalItemHistoryRecordedThroughOneRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const timelineResponseOutputSchedulesItemRoutinesItemFinalMax = 10000;

export const timelineResponseOutputSchedulesItemRoutinesItemGapsItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const timelineResponseOutputSchedulesItemRoutinesItemGapsItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const timelineResponseOutputSchedulesItemRoutinesItemGapsMax = 10000;

export const timelineResponseOutputSchedulesItemRoutinesMax = 10;

export const timelineResponseOutputSchedulesMax = 300;

export const timelineResponseOutputViewVersionMax = 256;

export const TimelineResponseOutput = zod.object({
  daySlices: zod
    .array(
      zod.object({
        start: zod.iso
          .datetime({ offset: true })
          .regex(timelineResponseOutputDaySlicesItemStartRegExp),
        end: zod.iso.datetime({ offset: true }).regex(timelineResponseOutputDaySlicesItemEndRegExp),
      }),
    )
    .max(timelineResponseOutputDaySlicesMax)
    .optional(),
  agents: zod
    .array(
      zod.object({
        id: zod.uuid().regex(timelineResponseOutputAgentsItemIdRegExp),
        displayName: zod.string().min(1).max(timelineResponseOutputAgentsItemDisplayNameMax),
        initials: zod.string().min(1).max(timelineResponseOutputAgentsItemInitialsMax),
      }),
    )
    .max(timelineResponseOutputAgentsMax)
    .optional(),
  range: zod.object({
    start: zod.iso.datetime({ offset: true }).regex(timelineResponseOutputRangeStartRegExp),
    end: zod.iso.datetime({ offset: true }).regex(timelineResponseOutputRangeEndRegExp),
  }),
  displayTimeZone: zod.string().min(1).max(timelineResponseOutputDisplayTimeZoneMax),
  schedules: zod
    .array(
      zod.object({
        scheduleId: zod.uuid().regex(timelineResponseOutputSchedulesItemScheduleIdRegExp),
        name: zod.unknown().and(zod.unknown()),
        timeZone: zod.string().min(1).max(timelineResponseOutputSchedulesItemTimeZoneMax),
        version: zod
          .int()
          .gt(timelineResponseOutputSchedulesItemVersionExclusiveMin)
          .max(timelineResponseOutputSchedulesItemVersionMax),
        routines: zod
          .array(
            zod.object({
              pendingHistory: zod
                .union([
                  zod.object({
                    start: zod.iso
                      .datetime({ offset: true })
                      .regex(
                        timelineResponseOutputSchedulesItemRoutinesItemPendingHistoryOneStartRegExp,
                      ),
                    end: zod.iso
                      .datetime({ offset: true })
                      .regex(
                        timelineResponseOutputSchedulesItemRoutinesItemPendingHistoryOneEndRegExp,
                      ),
                  }),
                  zod.null(),
                ])
                .optional(),
              routineId: zod
                .uuid()
                .regex(timelineResponseOutputSchedulesItemRoutinesItemRoutineIdRegExp),
              name: zod.unknown().and(zod.unknown()),
              rotation: zod.object({
                unit: zod.enum(['day', 'week']),
                count: zod
                  .int()
                  .gt(timelineResponseOutputSchedulesItemRoutinesItemRotationCountExclusiveMin)
                  .max(timelineResponseOutputSchedulesItemRoutinesItemRotationCountMax),
              }),
              original: zod
                .array(
                  zod.object({
                    start: zod.iso
                      .datetime({ offset: true })
                      .regex(
                        timelineResponseOutputSchedulesItemRoutinesItemOriginalItemStartRegExp,
                      ),
                    end: zod.iso
                      .datetime({ offset: true })
                      .regex(timelineResponseOutputSchedulesItemRoutinesItemOriginalItemEndRegExp),
                    source: zod.object({
                      scheduleId: zod
                        .uuid()
                        .regex(
                          timelineResponseOutputSchedulesItemRoutinesItemOriginalItemSourceScheduleIdRegExp,
                        ),
                      routineId: zod
                        .uuid()
                        .regex(
                          timelineResponseOutputSchedulesItemRoutinesItemOriginalItemSourceRoutineIdRegExp,
                        ),
                      routineVersionId: zod
                        .uuid()
                        .regex(
                          timelineResponseOutputSchedulesItemRoutinesItemOriginalItemSourceRoutineVersionIdRegExp,
                        ),
                      positionId: zod
                        .uuid()
                        .regex(
                          timelineResponseOutputSchedulesItemRoutinesItemOriginalItemSourcePositionIdRegExp,
                        ),
                      originalUserId: zod
                        .uuid()
                        .regex(
                          timelineResponseOutputSchedulesItemRoutinesItemOriginalItemSourceOriginalUserIdRegExp,
                        ),
                      originalEligible: zod.boolean(),
                      overrideId: zod.union([
                        zod
                          .uuid()
                          .regex(
                            timelineResponseOutputSchedulesItemRoutinesItemOriginalItemSourceOverrideIdOneRegExp,
                          ),
                        zod.null(),
                      ]),
                    }),
                    userId: zod.union([
                      zod
                        .uuid()
                        .regex(
                          timelineResponseOutputSchedulesItemRoutinesItemOriginalItemUserIdOneRegExp,
                        ),
                      zod.null(),
                    ]),
                    eligible: zod.boolean(),
                    startOffset: zod
                      .string()
                      .regex(
                        timelineResponseOutputSchedulesItemRoutinesItemOriginalItemStartOffsetRegExp,
                      ),
                    endOffset: zod
                      .string()
                      .regex(
                        timelineResponseOutputSchedulesItemRoutinesItemOriginalItemEndOffsetRegExp,
                      ),
                    history: zod.object({
                      recordedThrough: zod.union([
                        zod.iso
                          .datetime({ offset: true })
                          .regex(
                            timelineResponseOutputSchedulesItemRoutinesItemOriginalItemHistoryRecordedThroughOneRegExp,
                          ),
                        zod.null(),
                      ]),
                      finalized: zod.boolean(),
                    }),
                  }),
                )
                .max(timelineResponseOutputSchedulesItemRoutinesItemOriginalMax),
              overrides: zod
                .array(
                  zod.object({
                    overrideId: zod
                      .uuid()
                      .regex(
                        timelineResponseOutputSchedulesItemRoutinesItemOverridesItemOverrideIdRegExp,
                      ),
                    substituteUserId: zod
                      .uuid()
                      .regex(
                        timelineResponseOutputSchedulesItemRoutinesItemOverridesItemSubstituteUserIdRegExp,
                      ),
                    start: zod.iso
                      .datetime({ offset: true })
                      .regex(
                        timelineResponseOutputSchedulesItemRoutinesItemOverridesItemStartRegExp,
                      ),
                    end: zod.iso
                      .datetime({ offset: true })
                      .regex(timelineResponseOutputSchedulesItemRoutinesItemOverridesItemEndRegExp),
                    effective: zod.boolean(),
                    eligible: zod.boolean(),
                  }),
                )
                .max(timelineResponseOutputSchedulesItemRoutinesItemOverridesMax),
              final: zod
                .array(
                  zod.object({
                    start: zod.iso
                      .datetime({ offset: true })
                      .regex(timelineResponseOutputSchedulesItemRoutinesItemFinalItemStartRegExp),
                    end: zod.iso
                      .datetime({ offset: true })
                      .regex(timelineResponseOutputSchedulesItemRoutinesItemFinalItemEndRegExp),
                    source: zod.object({
                      scheduleId: zod
                        .uuid()
                        .regex(
                          timelineResponseOutputSchedulesItemRoutinesItemFinalItemSourceScheduleIdRegExp,
                        ),
                      routineId: zod
                        .uuid()
                        .regex(
                          timelineResponseOutputSchedulesItemRoutinesItemFinalItemSourceRoutineIdRegExp,
                        ),
                      routineVersionId: zod
                        .uuid()
                        .regex(
                          timelineResponseOutputSchedulesItemRoutinesItemFinalItemSourceRoutineVersionIdRegExp,
                        ),
                      positionId: zod
                        .uuid()
                        .regex(
                          timelineResponseOutputSchedulesItemRoutinesItemFinalItemSourcePositionIdRegExp,
                        ),
                      originalUserId: zod
                        .uuid()
                        .regex(
                          timelineResponseOutputSchedulesItemRoutinesItemFinalItemSourceOriginalUserIdRegExp,
                        ),
                      originalEligible: zod.boolean(),
                      overrideId: zod.union([
                        zod
                          .uuid()
                          .regex(
                            timelineResponseOutputSchedulesItemRoutinesItemFinalItemSourceOverrideIdOneRegExp,
                          ),
                        zod.null(),
                      ]),
                    }),
                    userId: zod.union([
                      zod
                        .uuid()
                        .regex(
                          timelineResponseOutputSchedulesItemRoutinesItemFinalItemUserIdOneRegExp,
                        ),
                      zod.null(),
                    ]),
                    eligible: zod.boolean(),
                    startOffset: zod
                      .string()
                      .regex(
                        timelineResponseOutputSchedulesItemRoutinesItemFinalItemStartOffsetRegExp,
                      ),
                    endOffset: zod
                      .string()
                      .regex(
                        timelineResponseOutputSchedulesItemRoutinesItemFinalItemEndOffsetRegExp,
                      ),
                    history: zod.object({
                      recordedThrough: zod.union([
                        zod.iso
                          .datetime({ offset: true })
                          .regex(
                            timelineResponseOutputSchedulesItemRoutinesItemFinalItemHistoryRecordedThroughOneRegExp,
                          ),
                        zod.null(),
                      ]),
                      finalized: zod.boolean(),
                    }),
                  }),
                )
                .max(timelineResponseOutputSchedulesItemRoutinesItemFinalMax),
              gaps: zod
                .array(
                  zod.object({
                    start: zod.iso
                      .datetime({ offset: true })
                      .regex(timelineResponseOutputSchedulesItemRoutinesItemGapsItemStartRegExp),
                    end: zod.iso
                      .datetime({ offset: true })
                      .regex(timelineResponseOutputSchedulesItemRoutinesItemGapsItemEndRegExp),
                    reason: zod.enum([
                      'outside-sections',
                      'before-start',
                      'ineligible',
                      'ended',
                      'archived',
                      'empty-dst-section',
                    ]),
                  }),
                )
                .max(timelineResponseOutputSchedulesItemRoutinesItemGapsMax),
            }),
          )
          .max(timelineResponseOutputSchedulesItemRoutinesMax),
      }),
    )
    .max(timelineResponseOutputSchedulesMax),
  viewVersion: zod.string().min(1).max(timelineResponseOutputViewVersionMax),
});

export type TimelineResponseOutput = zod.input<typeof TimelineResponseOutput>;
export type TimelineResponseOutputOutput = zod.output<typeof TimelineResponseOutput>;
